module.exports = __webpack_public_path__ + "img/wisa_pc_01.a4f260d9.png";